export const holidaysInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
